// src/hooks/useFirebaseNotifications.js
import { useEffect } from 'react';
import { generateToken, messaging } from '../notifications/firebase'; // your firebase utils
import { onMessage } from 'firebase/messaging';

export default function useFirebaseNotifications() {
  useEffect(() => {
    generateToken();

    const unsubscribe = onMessage(messaging, (payload) => {
      // console.log('Received foreground message:', payload);
      // TODO: show toast/alert for notification
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
